import tw, { styled } from 'twin.macro';

export const Container = styled.section`
  ${tw`container container-stack-context`}
  ${tw`flex justify-center`}
  ${tw`px-2 lg:px-0`}
`;

export const Buttons = styled.div`
  ${tw`flex flex-col lg:flex-row gap-2 lg:gap-3`}
`;

export const Wrapper = styled.div<{
  isFullWidth: boolean;
}>`
  ${tw`flex gap-4 lg:gap-5 items-center`}
  ${tw`flex-col lg:flex-row`}
  ${tw`py-4 lg:py-3 px-2 lg:px-6`}
  ${tw`rounded-lg`}
  ${tw`bg-neutrals-n1`}
  ${tw`border-4 border-primary-p1`}
  ${({ isFullWidth }) => isFullWidth && tw`w-full justify-evenly`}
`;

export const Text = styled.div`
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-primary-p1`}
  ${tw`text-mobile-heading-s lg:text-heading-s`}
  ${tw`text-center lg:text-left`}
`;
